import { render, staticRenderFns } from "./ChooseLanguageModal.vue?vue&type=template&id=df5f4c5c&"
import script from "./ChooseLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ChooseLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLanguageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports